(function () {
    'use strict';

    angular
        .module('app')
        .config(['$routeProvider', appRoutes]);

    appRoutes.$inject = ['$routeProvider'];

    function appRoutes($routeProvider) {

        $routeProvider.when("/home",
        {
            redirectTo: "/login"
        });


        $routeProvider.when("/routetoorder",
        {
            resolve: {
                'ChangeModule': function ($window, moduleURLs) {
                    $window.location.href = moduleURLs.orderUrl;
                }
            }
        });

        $routeProvider.when("/routetosys",
         {
             resolve: {
                 'ChangeModule': function ($window, moduleURLs) {
                     $window.location.href = moduleURLs.sysUrl;
                 }
             }
         });

        $routeProvider.when("/routetobp",
         {
             resolve: {
                 'ChangeModule': function ($window, moduleURLs) {
                     $window.location.href = moduleURLs.bpUrl;
                 }
             }
         });

        $routeProvider.when("/routetojob",
         {
             resolve: {
                 'ChangeModule': function ($window, moduleURLs) {
                     $window.location.href = moduleURLs.jobUrl;
                 }
             }
         });

        $routeProvider.when("/routetoinv",
         {
             resolve: {
                 'ChangeModule': function ($window, moduleURLs) {
                     $window.location.href = moduleURLs.productUrl;
                 }
             }
         });

        $routeProvider.otherwise({
            redirectTo: "/login"
        });
      
    }

})();